<template>
    <div class="index">
        <div class="search-wrap flex">
            <a @click="goSearch" class="search-link"
                >输入股票代码/首字母查询个股详情</a
            >
            <a @click="goHome" class="link-btn">全市场</a>
        </div>
        <section class="mod mod2">
            <dl class="mod-top">
                <dt>
                    {{ stockInform.stockName
                    }}<small>{{ stockInform.stockCode.slice(2) }}</small>
                </dt>
                <dd>
                    <span :class="stockInform.value | formateRedGreen">{{
                        stockInform.value
                    }}</span
                    ><span :class="stockInform.rate | formateRedGreen"
                        >{{ stockInform.rate | formatePrefixData }}%</span
                    >
                </dd>
            </dl>
            <a class="link-more link-text-r" @click="gogufs">查看详情</a>
            <div class="chart-info flex">
                <div>
                    持仓市值<strong :class="ccsz | formateRedGreen">{{
                        ccsz | num(["亿", "万亿"], "亿")
                    }}</strong>
                </div>
                <div>
                    持股占流通比<strong>{{ cglt }}%</strong>
                </div>
                <div>
                    较上期<strong :class="jml | formateRedGreen">{{
                        jml | num(["万", "亿", "万亿"], "万")
                    }}</strong>
                </div>
            </div>
            <div style="text-align: right">数据日期: {{ timeInfo }}</div>
        </section>

        <!-- <section class="mod">
      <div class="nav-sub-cont">
        <div class="chart-legent">
          <span class="legent-rect legent">北向资金线<i class="tips"></i></span>
        </div>
        <div id="kline" class="chart chart-history klinebox"></div>
      </div>
    </section> -->

        <section class="mod">
            <h2 class="mod-tit">成分股持仓市值</h2>
            <!-- <div class="date-title" style="position: sticky;top: 0;background: #FFF;margin:0;padding:0.4rem 0;">
        <ul class="date-list flex">
          <li v-for="(date,i) in dateList" :key="i" :class="curDateIndex==i?'cur':''" @click="checkDay(i)">{{date}}</li>
        </ul>
      </div> -->
            <div class="date-title">数据日期: {{ timeInfo2 }}</div>
            <div class="table-scroll table-scroll-h">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr style="position: sticky; top: 0rem; background: #fff">
                        <th>名称代码</th>
                        <th
                            :class="`${
                                banKuaiSoringName === 'ChiGuShiZhi' &&
                                banKuaiSoring === true
                                    ? 'sort'
                                    : ''
                            }${
                                banKuaiSoringName === 'ChiGuShiZhi' &&
                                banKuaiSoring === false
                                    ? 'sort up'
                                    : ''
                            }`"
                            @click="sorting('ChiGuShiZhi')"
                        >
                            持仓市值
                        </th>
                        <th
                            :class="`${
                                banKuaiSoringName === 'ChiGuShiZhiBianHua1' &&
                                banKuaiSoring === true
                                    ? 'sort'
                                    : ''
                            }${
                                banKuaiSoringName === 'ChiGuShiZhiBianHua1' &&
                                banKuaiSoring === false
                                    ? 'sort up'
                                    : ''
                            }`"
                            @click="sorting('ChiGuShiZhiBianHua1')"
                        >
                            较上期变动
                        </th>
                        <!-- <th

                        >
                            较上期变动
                        </th> -->
                        <!-- <th
                            :class="`${
                                banKuaiSoringName === 'ChiGuZhangFu' &&
                                banKuaiSoring === true
                                    ? 'sort'
                                    : ''
                            }${
                                banKuaiSoringName === 'ChiGuZhangFu' &&
                                banKuaiSoring === false
                                    ? 'sort up'
                                    : ''
                            }`"
                            @click="sorting('ChiGuZhangFu')"
                        >
                            区间涨跌幅
                        </th> -->
                    </tr>
                    <tr v-for="(item, index) in topTenList" :key="index">
                        <td @click="goLink(item.Obj)">
                            {{ item.ZhongWenJianCheng
                            }}<small>{{ item.Obj }}</small>
                        </td>
                        <td :class="item.ChiGuShiZhi | formateRedGreen">
                            {{
                                item.ChiGuShiZhi
                                    | num(["万", "亿", "万亿"], "亿")
                            }}
                        </td>
                        <td :class="item.ChiGuShiZhiBianHua | formateRedGreen">
                            {{
                                item.ChiGuShiZhiBianHua
                                    | num(["万", "亿", "万亿"], "万")
                            }}
                        </td>
                        <!-- <td :class="item.ChiGuZhangFu | formateRedGreen">
                            {{ item.ChiGuZhangFu }}%
                        </td> -->
                    </tr>
                </table>
            </div>
        </section>
    </div>
</template>

<script>
import { stockinfo, cgbl } from "@/api/index.js";
import { getBanKuaiTj } from "@/api/xqDetail.js";
import { getUrlQuery, maxSorting, minSorting } from "@/utils/handleUrl.js";

import { share } from "@/lib/dzh";
import wxshare from "@/assets/js/wxshare";

export default {
    name: "ggDetail",
    data() {
        return {
            stockCode: "", //股票代码
            version: "", //当前版本客户端
            stockInform: {
                stockName: "",
                stockCode: "",
                value: "",
                rate: "",
            },
            ccsz: "",
            cglt: "",
            jml: "",
            timeInfo: "",
            timeInfo2: "",
            lastYear: "",
            firstTime: "",
            cgbh: {
                value: "",
                max: "",
                min: "",
                latest: "",
            },
            chartData: [],
            chartStart: 80,
            chartEnd: 100,
            chartLength: 0,
            klineList: [],
            chartDom: null,
            token: "", //云平台token
            userToken: "", //用户token
            topTenList: [],
            curDateIndex: 0,
            dateList: ["当日", "近5日", "近20日", "近60日"],
            banKuaiSoringName: "ChiGuShiZhi", //板块列表排序字段
            banKuaiSoring: true, //判断正序还是倒叙
            page: 1,
            pageSize: 20,
            queryShow: false, //判断请求是否完成
            allQuery: false, //判断是否已请求全部数据
            websocket: null,
        };
    },
    filters: {
        formatePrefixData: function (v) {
            if (v == undefined || v == null || !v) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
        num(num, arr, type) {
            if (!num && num !== 0) {
                return "";
            } else {
                let str = Number(num);
                if (num > 0) {
                    let param = {};
                    let k = 10000;
                    let sizes = arr;
                    let i;
                    if (num < k) {
                        param.value = num;
                        param.unit = type;
                    } else {
                        i = Math.floor(Math.log(num) / Math.log(k));
                        param.value = (num / Math.pow(k, i)).toFixed(2);
                        param.unit = sizes[i];
                    }
                    return (
                        parseFloat(param.value.toString()).toFixed(2) +
                        param.unit
                    );
                } else if (num < 0) {
                    let param = {};
                    let k = 10000;
                    let sizes = arr;
                    let i;
                    num = -num;
                    if (num < k) {
                        param.value = -num;
                        param.unit = type;
                    } else {
                        i = Math.floor(Math.log(num) / Math.log(k));
                        param.value = -(num / Math.pow(k, i)).toFixed(2);
                        param.unit = sizes[i];
                    }
                    return (
                        parseFloat(param.value.toString()).toFixed(2) +
                        param.unit
                    );
                } else if (num === 0) {
                    return 0.0;
                }
                return parseFloat(str).toFixed(2);
            }
        },
    },
    computed: {
        market() {
            return this.stockCode.slice(0, 2) === "SH" ? "沪" : "深";
        },
    },
    created() {
        this.lastYear = this.getLastYear();
        this.stockCode = decodeURIComponent(getUrlQuery("code"));
        this.userToken = getUrlQuery("token");
        this.version = getUrlQuery("version");
        wxshare.do(
            this.$route.fullPath,
            "http://static.yundzh.com/logo.png",
            "沪深港通"
        );
    },
    mounted: function () {
        this.stockInform.stockName = decodeURIComponent(getUrlQuery("name"));
        this.getYunToken();
        this.getChartInfoData();
        this.getIngredients();
        window.addEventListener("scroll", this.scrollChange, true);
        document.title = "沪深港通";
        share("沪深港通", this.$route.fullPath);
    },
    methods: {
        // 跳转到板块分时
        gogufs: function () {
            location.href = `dzh_browser_url&goto=0&type=2970&code=${this.stockCode.replace(
                "B$",
                "BI"
            )}&kind=0`;
        },
        // goLink
        goLink: function (code) {
            window.location.href = `dzh_browser_url&goto=0&type=2970&code=${code}&kind=1`;
        },
        // 跳转到搜索页
        goSearch: function () {
            this.$router.push("/search");
        },
        // 跳转到首页
        goHome: function () {
            this.$router.push("/");
        },
        // 获取云平台token
        getYunToken: function () {
            let that = this;
            stockinfo().then((res) => {
                that.token = res.data.data.token;
                that.$nextTick(() => {
                    const data = res.data.data;
                    that.getStocksZf(data.url, data.token);
                });
            });
        },
        //获取当前个股加个以及涨幅
        getStocksZf: function (url, token) {
            let that = this;
            if (!this.websocket) {
                this.websocket = new WebSocket(`${url}/ws?token=${token}`);
                this.websocket.onopen = () => {
                    this.websocketSend();
                };
            } else {
                this.websocket.send(`/cancel?qid=1`);
                this.websocketSend();
            }
            this.websocket.onmessage = (evt) => {
                let fr = new FileReader();
                fr.readAsText(evt.data);
                fr.onload = () => {
                    let result = JSON.parse(fr.result);
                    let dynaList = result.Data.RepDataStkData;
                    if (dynaList) {
                        that.stockInform = {
                            stockName: dynaList[0].ZhongWenJianCheng,
                            stockCode: dynaList[0].Obj,
                            value: dynaList[0].ZuiXinJia,
                            rate: dynaList[0].ZhangFu,
                        };
                    }
                };
            };
            this.websocket.onclose = () => {
                this.websocket.close();
                this.websocket = null;
                this.getYunToken();
            };
        },

        websocketSend() {
            this.websocket.send(
                `/stkdata?obj=${this.stockCode}&field=ZhongWenJianCheng,JiaoYiDaiMa,ZuiXinJia,ZhangFu&qid=1&sub=1`
            );
        },

        // 获取持仓市值、流通比、净买量等数据
        getChartInfoData: function () {
            let that = this;
            getBanKuaiTj({ obj: this.stockCode, token: this.userToken }).then(
                (res) => {
                    if (res.data.err === 0) {
                        let data = res.data.data.list[0];
                        that.ccsz = data.ChiGuShiZhi;
                        that.cglt = data.ZhanLiuTongGuBiLi;
                        that.jml = data.ChiGuShiZhiBianHua;
                        that.timeInfo = res.data.data.time;
                    }
                }
            );
        },
        formatDate(timestamp, formatStr = "YYYY-MM-dd HH:mm:ss") {
            let date = timestamp ? new Date(timestamp * 1000) : new Date();
            const REGEX_FORMAT =
                /\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
            const matches = {
                YYYY: date.getFullYear(),
                MM: this.padStart(date.getMonth() + 1, 2, "0"),
                dd: this.padStart(date.getDate(), 2, "0"),
                HH: this.padStart(date.getHours(), 2, "0"),
                mm: this.padStart(date.getMinutes(), 2, "0"),
                ss: this.padStart(date.getSeconds(), 2, "0"),
            };
            let str = formatStr;
            return str.replace(
                REGEX_FORMAT,
                (match, $1) => $1 || matches[match]
            );
        },
        padStart(string, length, pad) {
            const s = String(string);
            if (!s || s.length >= length) return string;
            return `${Array(length + 1 - s.length).join(pad)}${string}`;
        },
        getLastYear() {
            let that = this;
            let date = new Date();
            let year = date.getFullYear() - 1;
            let timestamp = date.setFullYear(year) / 1000;
            return that.formatDate(timestamp, "YYYYMMdd");
        },
        // 获取成分股净流入
        getIngredients: function () {
            let that = this;
            if (that.queryShow) return;
            that.queryShow = true;
            let obj = {
                token: that.userToken,
                block:
                    "股票/大智慧自定义/指数板块/" + that.stockInform.stockName,
                start: (that.page - 1) * that.pageSize + 1,
                count: that.pageSize,
                orderby: that.banKuaiSoringName,
                desc: that.banKuaiSoring,
            };
            if (that.curDateIndex === 0) {
                // obj.day = 1
            } else if (that.curDateIndex === 1) {
                obj.day = 5;
            } else if (that.curDateIndex === 2) {
                obj.day = 20;
            } else if (that.curDateIndex === 3) {
                obj.day = 60;
            }
            getBanKuaiTj(obj).then((res) => {
                that.queryShow = false;
                if (res.data.err === 0) {
                    that.timeInfo2 = res.data.data.time;
                    if (that.banKuaiSoring) {
                        that.topTenList = minSorting(
                            [...that.topTenList, ...res.data.data.list],
                            that.banKuaiSoringName
                        );
                    } else {
                        that.topTenList = maxSorting(
                            [...that.topTenList, ...res.data.data.list],
                            that.banKuaiSoringName
                        );
                    }
                    if (res.data.data.list.length < 20) {
                        that.allQuery = true;
                    }
                }
            });
        },
        // 点击切换日期
        checkDay(index) {
            let that = this;
            that.curDateIndex = index;
            that.topTenList = [];
            that.page = 1;
            that.allQuery = false;
            that.banKuaiSoring = true;
            that.banKuaiSoringName = "ChiGuShiZhiBianHua";
            that.$nextTick(() => {
                that.getIngredients();
            });
        },
        // 点击排序
        sorting(type) {
            let that = this;
            let arr;
            if (type === that.banKuaiSoringName) {
                // if (that.banKuaiSoring) {
                //     arr = maxSorting(that.topTenList, that.banKuaiSoringName);
                // } else {
                //     arr = minSorting(that.topTenList, that.banKuaiSoringName);
                // }
                // that.topTenList = arr;
                that.banKuaiSoringName = type;
                that.banKuaiSoring = !that.banKuaiSoring;
                that.page = 1;
                that.pageSize = 20;
                that.topTenList = [];
                this.getIngredients();
            } else {
                that.banKuaiSoring = true;
                that.$nextTick(() => {
                    // if (that.banKuaiSoring) {
                    //     arr = minSorting(that.topTenList, type);
                    // } else {
                    //     arr = maxSorting(that.topTenList, type);
                    // }
                    // that.topTenList = arr;
                    that.banKuaiSoringName = type;
                    that.page = 1;
                    that.pageSize = 20;
                    that.topTenList = [];
                    this.getIngredients();
                });
            }
        },
        // 页面下拉添加数据
        scrollChange() {
            let that = this;
            var scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            var windowHeight =
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            var scrollHeight =
                document.documentElement.scrollHeight ||
                document.body.scrollHeight;
            if (scrollTop + windowHeight >= scrollHeight) {
                if (!that.queryShow && !that.allQuery) {
                    that.page = that.page + 1;
                    that.$nextTick(() => {
                        that.getIngredients();
                    });
                }
            }
        },
    },
    destroyed() {
        // 离开该页面需要移除这个监听的事件，不然会报错
        window.removeEventListener("scroll", this.scrollChange, true);
    },
};
</script>
